export default __webpack_public_path__ + "static/media/laravel.6f8afa80.svg";